<template>
  <div id="app">
    <div
      class="Banner fadeBanner-leave-active"
      id="banner"
      v-if="$data.bannerDisplay.display || ifHasError"
    >
      <div class="clearfix">
        <a
          v-if="false && $data.bannerDisplay.copicate"
          href="#profitlossMode_switcher"
          @click.prevent="setProfitlossMode(true)"
          class="copicate"
        >
          {{ $t("banner.copicate") }}
        </a>
        <p v-if="ifHasError" class="text-danger m-0">
          {{ $t("banner.error") }}
        </p>
      </div>
    </div>
    <div>
      <div class="container top-bar mb-4">
        <div class="row">
          <div class="col-4 col-lg-4 col-xl-3 offset-xl-1">
            <Logo />
          </div>

          <div
            class="col-8 col-lg-8 col-xl-7 flex-center-right"
            v-if="$route.name !== 'share'"
          >
            <AboutMenu />
            <CurrencyMenu />
            <LanguageMenu />
            <UserMenu />
          </div>

          <div
            class="col-8 col-lg-8 col-xl-7 flex-center-right"
            v-if="$route.name === 'share'"
          >
            <router-link to="/" class="btn btn-primary share-button">
              {{ $t("share_page.create_own_free") }}
            </router-link>
          </div>
        </div>
      </div>

      <div id="content" class="container">
        <div class="row">
          <div class="col-12 col-lg-12 col-xl-10 offset-xl-1">
            <router-view></router-view>
          </div>
        </div>
      </div>

      <Footer />
    </div>
    <SignInDialog v-if="uiDialogs.signIn" />
    <ShareDialog v-if="uiDialogs.share" />
    <ProfitlossDeleteAllDialog v-if="uiDialogs.profitlossDeteleAll" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Options from "./options";

import Logo from "./components/Logo";

import SignInDialog from "./components/dialogs/SignIn.vue";
import ShareDialog from "./components/dialogs/Share.vue";
import ProfitlossDeleteAllDialog from "./components/dialogs/ProfitlossDeleteAllDialog.vue";

import UserMenu from "./components/UserMenu.vue";
import CurrencyMenu from "./components/CurrencyMenu.vue";
import AboutMenu from "./components/specials/AboutMenu.vue";
import LanguageMenu from "./components/LanguageMenu.vue";
import Footer from "./components/Footer.vue";

export default {
  name: "app",
  metaInfo() {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: this.$route.name === "share" ? "CoinTrackr" : this.shareRouteTitle,
      // all titles will be injected into this template
      titleTemplate: "%s | Live Crypto Price Tracker, Portfolio & Review",
    };
  },
  components: {
    LanguageMenu,
    Logo,
    UserMenu,
    AboutMenu,
    CurrencyMenu,
    SignInDialog,
    ShareDialog,
    ProfitlossDeleteAllDialog,
    Footer,
  },
  data() {
    const today = new Date(Date.now()).getDay();
    const initialBannerParams = {
      display: true,
      day: today,
      copicateDisplayed: false,
      antimonitorDisplayed: false,
    };
    let bannerParams =
      localStorage.getItem("banner") &&
      JSON.parse(localStorage.getItem("banner"));
    if (!bannerParams) {
      bannerParams = initialBannerParams;
    }
    if (bannerParams.day !== today) {
      bannerParams = initialBannerParams;
    } else {
      if (bannerParams.copicateDisplayed && bannerParams.antimonitorDisplayed) {
        bannerParams.display = false;
      }
    }
    const randomBoolean = !!Math.round(Math.random());
    const bannerDisplay = {
      copicate: !bannerParams.copicateDisplayed && randomBoolean,
      antimonitor:
        (!bannerParams.antimonitorDisplayed && !randomBoolean) ||
        (bannerParams.copicateDisplayed && !bannerParams.antimonitorDisplayed),
      display: bannerParams.display,
    };
    if (bannerDisplay.copicate) {
      bannerParams.copicateDisplayed = true;
    }
    if (bannerDisplay.antimonitor) {
      bannerParams.antimonitorDisplayed = true;
    }
    localStorage.setItem("banner", JSON.stringify(bannerParams));

    return {
      bannerDisplay,
    };
  },
  computed: {
    ...mapGetters({
      ifHasError: "coinmarketcap/ifHasError",
      interval: "coinmarketcap/interval",
      uiDialogs: "ui/dialogs",
      shareRouteTitle: "title",
      isLoggedIn: "auth/isLoggedIn",
    }),
  },
  methods: {
    setProfitlossMode(value) {
      this.setSetting({ setting: "profitlossMode", value });
      setTimeout(() => {
        document.querySelector("#profitlossMode_switcher").scrollIntoView({
          behavior: "smooth",
        });
      }, 100);
    },
    ...mapActions({
      setSetting: "settings/setSetting",
      startCoinMarketCapInterval: "coinmarketcap/startCoinMarketCapInterval",
      stopCoinMarketCapInterval: "coinmarketcap/stopCoinMarketCapInterval",
      getCoinMarketCapData: "coinmarketcap/getCoinMarketCapData",
      getCurrencyConversionRates: "currency/getCurrencyConversionRates",
      // startFetchAllExchangeDataInterval:
      //   "exchange/startFetchAllExchangeDataInterval",
      // stopFetchAllExchangeDataInterval:
      //   "exchange/stopFetchAllExchangeDataInterval",
    }),
  },
  async mounted() {
    await this.getCurrencyConversionRates();
    await this.getCoinMarketCapData();
    this.startCoinMarketCapInterval();
    // if (this.isLoggedIn) {
    //   this.startFetchAllExchangeDataInterval();
    // }
  },
  beforeDestroy() {
    this.stopCoinMarketCapInterval();
    // this.stopFetchAllExchangeDataInterval();
  },
};
</script>

<style lang="scss">
@import "~@/scss/bootstrap";
@import "~@/scss/variables";
@import "~@/scss/mixins";

// .HODL {
//   display: block;
//   width: 25px;
//   margin: 0 auto;
//   opacity: 0;
//   cursor: pointer;

//   &:hover,
//   &--Active {
//     opacity: 1;
//   }
// }

@include breakpoint-manual(max-width, $break-small) {
  .container,
  .container-sm {
    max-width: 100%;
  }
}

.fadeBanner-leave-active {
  transition: opacity 0.25s ease-out;
}

.fadeBanner-leave-to {
  opacity: 0;
}

.Banner {
  display: block;
  color: white;
  margin-top: -25px;
  margin-bottom: 10px;
  padding: 0.5rem;
  background: #1a224a;
  text-align: center;

  img {
    width: 6em;
    margin-right: 6px;
  }

  // a {
  //   color: $color-primary;
  // }

  button {
    color: white;
    margin-top: 7px;
  }
}
.copicate {
  font-size: 16px;
  color: #ffad01;
  animation: 1s linear 0s infinite alternate underline_blink;
  text-decoration: underline 0.1em rgba(255, 255, 255, 0);
  text-underline-position: under;
  transition: color 1s, text-decoration 1s;
  &:hover,
  &:focus {
    color: #fff;
    animation: 1s linear 0s infinite alternate underline_blink_alt;
    text-decoration: underline 0.15em rgba(255, 173, 1, 0);
  }
}
@keyframes underline_blink {
  from {
    text-decoration-color: rgba(255, 255, 255, 0);
  }
  to {
    text-decoration-color: rgba(255, 255, 255, 1);
  }
}
@keyframes underline_blink_alt {
  from {
    text-decoration-color: rgba(255, 173, 1, 0);
  }
  to {
    text-decoration-color: rgba(255, 173, 1, 1);
  }
}
</style>
